module.exports = __webpack_public_path__ + "img/18.6a919ca9.jpg";